'use client';

import { CTAButton } from '../../../components/Clickables/Buttons/CTAButton/CTAButton';
import { ProPlanId } from '../../../constants/premium';
import { useCurrentURL } from '../../../helpers/hooks/useCurrentURL/useCurrentURL';
import { useIsMobileDevice } from '../../../helpers/hooks/useIsMobileDevice';
import {
  companiesURLParameters,
  flowsURLParameters,
  URLParameters,
} from '../../Onboarding/constants/url';

export const ProSectionCTA = ({
  partnerFlow,
  proPlanId,
}: {
  partnerFlow?: boolean;
  proPlanId?: ProPlanId;
}) => {
  const isMobileDevice = useIsMobileDevice();
  const { addParameters } = useCurrentURL();
  const redeemLink = addParameters({
    [URLParameters.Company]: companiesURLParameters.aspira,
    [URLParameters.Flow]: flowsURLParameters.aspira.becomePro,
  });
  return partnerFlow
    ? !isMobileDevice && (
        <CTAButton
          type="pro"
          routerPushTo={redeemLink}
          source="ProBanner"
          variant="buttonPro"
          className="mb-6 w-full px-6 sm:w-max md:px-12"
        >
          Sign up to redeem
        </CTAButton>
      )
    : !isMobileDevice && (
        <CTAButton
          type="pro"
          proPlanId={proPlanId}
          source="ProSection"
          variant="buttonPro"
          className="my-4"
        >
          Unlock with Fishbrain Pro
        </CTAButton>
      );
};
